// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5980) return "static/chunks/5980-b4a7bfb265537bcb.js";
	if (chunkId === 1106) return "static/chunks/1106-42161589a504504e.js";
	if (chunkId === 3958) return "static/chunks/3958-1dd47856807260fb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"447":"13f2fe7dff189749","2293":"2bdd61f0badd927b","4792":"933e1eed007c703b"}[chunkId] + ".js";
};